import * as THREE from 'three';

const trunkMaterial = new THREE.MeshStandardMaterial({ color: '#6b4a30', roughness: 0.9 });

/** @param canopyMaterial shared, tier-tinted material owned by Village.ts */
export function createTree(position: THREE.Vector3, canopyMaterial: THREE.Material, scale = 1): THREE.Group {
  const group = new THREE.Group();

  const trunk = new THREE.Mesh(new THREE.CylinderGeometry(0.12, 0.16, 0.9, 6), trunkMaterial);
  trunk.position.y = 0.45;
  trunk.castShadow = true;
  group.add(trunk);

  const canopy = new THREE.Mesh(new THREE.ConeGeometry(0.7, 1.4, 8), canopyMaterial);
  canopy.position.y = 1.5;
  canopy.castShadow = true;
  group.add(canopy);

  group.position.copy(position);
  group.scale.setScalar(scale);
  return group;
}

export function disposeTreeMaterials(): void {
  trunkMaterial.dispose();
}
